import React from 'react';

import * as Styled from './side-navigation-panel.style';

export type SideNavigationPanelItemProps = {
  children: React.ReactNode;
};

export const SideNavigationPanelItem: React.FC<
  SideNavigationPanelItemProps
> = ({ children }) => <Styled.ListItem>{children}</Styled.ListItem>;
